import { SAVINGS_PLAN_SET_QUOTES } from '../constants'

export function setQuotes(quotes) {
    return dispatch => {
        dispatch({
            type: SAVINGS_PLAN_SET_QUOTES,
            data: {
                quotes
            }
        })
    }
}

export function reducer(state, action) {
    if (action.type === SAVINGS_PLAN_SET_QUOTES) {
        const { quotes } = action.data
        const entregaUsados = quotes.map(({ quote: q }) => {
            const estimatedPrice = q.quote.prices.find(price => price.type === 'estimated') || 0
            return {
                brand: q.vehicle.brandName,
                brandId: q.vehicle.brand,
                model: q.vehicle.modelName,
                modelId: q.vehicle.model,
                version: q.vehicle.versionName,
                versionId: q.vehicle.version,
                year: q.vehicle.year,
                final_take_price: estimatedPrice.amount * 1,
                original_price: estimatedPrice.amount * 1,
                quotation_id: q.id,
                km: q.kms,
                kilometraje: q.kms
            }
        })
        return {
            ...state,
            quotes: quotes.map(({ quote }) => ({ quote_id: quote.id })),
            entregaUsados
        }
    } else return state
}
